import {useQuery, type UseQueryOptions} from 'react-query';
import {
	fetchUnreadNotificationsCount,
	type UnreadNotificationsCountResponse,
} from '../../http/notifications/fetchUnreadNotificationsCount';
import {unreadNotificationsCountQueryKey} from './queryKeys';

export function useUnreadNotificationsCount(options?: UseQueryOptions<UnreadNotificationsCountResponse>) {
	return useQuery<UnreadNotificationsCountResponse>({
		queryKey: unreadNotificationsCountQueryKey,
		queryFn: async ({signal}) => {
			const {data} = await fetchUnreadNotificationsCount(signal);

			return data;
		},
		refetchInterval: 30_000,
		retry: false,
		...options,
	});
}
